import { Accordion, Text } from '@mantine/core';
import React, { memo, PropsWithChildren } from 'react';

interface Props {
	controlElement?: JSX.Element;
	controlTitle?: string;
	withBackground?: boolean;
	noHover?: boolean;
	value: string;
}

const CapChartSecuritiesAccordionContent = ({
	controlTitle,
	controlElement,
	withBackground,
	noHover,
	value,
	children,
}: PropsWithChildren<Props>) => {
	return (
		<Accordion.Item value={value} c="gray.4" style={{ borderBottom: 'none' }}>
			<Accordion.Control
				pl="0.5rem"
				pr="0.5rem"
				sx={(theme) => ({
					...(withBackground ? { backgroundColor: theme.colors.gray[0] } : {}),
					...(noHover
						? {
								'&:hover': {
									backgroundColor: 'transparent',
								},
							}
						: {}),
					'.mantine-Accordion-label': {
						paddingTop: '1rem',
						paddingBottom: '1rem',
					},
				})}
			>
				{controlElement ?? (
					<Text size="B6Bold" c="dark.4">
						{controlTitle}
					</Text>
				)}
			</Accordion.Control>
			<Accordion.Panel>{children}</Accordion.Panel>
		</Accordion.Item>
	);
};

const Memoized = memo(CapChartSecuritiesAccordionContent);

export { Memoized as CapChartSecuritiesAccordionContent };
